import {
  GET_WASTED_MENU_DATA,
  LOAD_MORE_WASTED_MENU_DATA
} from "../types";
import axios from "axios";
import {firebase} from '../../../firebase/initFirebase'
import moment from 'moment'
import {store} from '../../store'
import { message} from 'antd';
import S3 from 'react-aws-s3';



export const getWastedMenuData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name

    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('wastedmenu') 
      console.log(props)
    
      dataRef = dataRef.orderBy("wasted_date","desc")
      // if(props.salesStatus){
      //   dataRef = dataRef.where("status", "==", "completed")        
      // }
      dataRef = dataRef.where("status", "==", "completed")        
      if(userRole !== 'admin' && userRole !== 'manager'){
    
        dataRef = dataRef.where("branch", "==", userLocation)   
      }

      console.log(props)
      // if(props.searchText){
      //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
      // }
      // if(props.filters){
      //   if(props.filters.length > 0){
      //     props.filters.map(item=>{
      //       console.log(item)
      //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
      //     })
      //   }       
      // }

      dataRef = dataRef.limit(40)
    
      var documentSnapshots = await dataRef.get()

      var docs = documentSnapshots.docs
      var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
      var dataArray =[]

      await Promise.all(docs.map(async (salesItem) => {    
        var newOrder={
            key:salesItem.id,
            id:salesItem.id,
            ...salesItem.data()
        }

   

        dataArray.push(newOrder)
      }));
      dispatch({ type: GET_WASTED_MENU_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible, currentProps:props } }) 

      
  };
};

export const loadMoreWastedMenuData = () => {
  return async(dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email
    var currentLastItem = reduxState.dailysales.lastVisible
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name

    var currentProps = reduxState.dailysales.currentProps
    var Firestore = firebase.firestore();
    
    var dataRef = Firestore.collection(currentProps.apiurl) 

      dataRef = dataRef.orderBy("sale_date","desc") 
          
    
      // if(currentProps.salesStatus){
      //   dataRef = dataRef.where("status", "==", currentProps.salesStatus)        
      // }
      dataRef = dataRef.where("status", "==", "completed")    
      if(userRole !== 'admin' && userRole !== 'manager'){
        dataRef = dataRef.where("branch", "==", userLocation)   

      }

      if(currentLastItem){
        dataRef = dataRef.startAfter(currentLastItem)
              
      
        // if(currentProps.searchText){
        //   dataRef = dataRef.where('name', '>=', currentProps.searchText).where('name', '<=', currentProps.searchText+ '\uf8ff')
        // }

        dataRef = dataRef.limit(100)
 
        var documentSnapshots = await dataRef.get()
        var docs = documentSnapshots.docs
        if(docs){
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
          var dataArray =[]
          await Promise.all(docs.map(async (salesItem) => {    
            var newOrder={
                key:salesItem.id,
                id:salesItem.id,
                ...salesItem.data()
            }
  
     
            dataArray.push(newOrder)
          }));
          if(lastVisible && currentLastItem !== lastVisible){

            dispatch({ type: LOAD_MORE_WASTED_MENU_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible} })  
          }else{
            message.error('No More Items To Load');
          }
        }else{
          message.error('No More Items To Load');
        }
    }
  };
};








export const setWastedMenu = (products_sold,save_ingredients,createDate) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name


    var salesRef = Firestore.collection('wastedmenu').doc()
 
  
    console.log(save_ingredients)
    var salesData = { 
      status: 'completed',
      wasted_date: createDate.format('YYYY-MM-DD HH:mm:ss'),
      created_at: moment().format('YYYY-MM-DD HH:mm:ss'),            
      created_by:userID,
      created_name:userName, 
      branch:userLocation,
      branch_name:userLocationName,
      products_wasted:products_sold,
      used_ingredients:save_ingredients

    }
    console.log(salesData)

    var salesndone = await salesRef.set(salesData,{merge: true})

    return('oks')
  };
};



export const voidWastedMenu = (record) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name


    var salesRef = Firestore.collection('wastedmenu').doc(record.id)
 

    var salesData = { 
      status: 'voided',
      voided_at: moment().format('YYYY-MM-DD HH:mm:ss'),            
      voided_by:userID,
      voided_name:userName, 
    }
    console.log(salesData)

    var salesndone = await salesRef.set(salesData,{merge: true})

    return('oks')
  };
};

